const store = {
  namespaced: true,
  state: {
    type: null,
    title: null,
    message: null,
  },
  getters: {},
  mutations: {
    updateToast(state, payload) {
      state.type = payload.type;
      state.title = payload.title;
      state.message = payload.message;

      this._vm.$vtNotify({
        title: state.title,
        body: state.message,
        type: state.type,
        theme: this.state.theme
      });
    },
  },
  actions: {
    updateToast({ commit }, payload) {
      commit("updateToast", payload);
    },
  },
};

export default store;
